import React, {
    useState,
    useEffect
} from 'react';
import {
    Table,
    Container,
    FormControl,
    DropdownButton,
    Dropdown,
    Accordion,
    AccordionToggle,
    AccordionCollapse,
    Card
} from 'react-bootstrap';
import '../../styles/MembersTable.css';
import { HHIEButton } from '../utility/HHIEButton';

export default function AdminConfig(props) {
    const [clicked, setClicked] = useState(false);
    const [clickedId, setClickedId] = useState("");
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);
    const [loadingQuestions, setLoadingQuestions] = useState(true);
    const [configs, setConfigs] = useState(null);
    const [questions, setQuestions] = useState(null);
    const [newQuestion, setNewQuestion] = useState("");
    const [minQuestions, setMinQuestions] = useState();
    const [newMemberTimer, setNewMemberTimer] = useState("15 minutes");
    const [dailyTimer, setDailyTimer] = useState("8 am");
    const [reportTimer, setReportTimer] = useState("Daily");
    const [pocRegReportTimer, setPocRegReportTimer] = useState("Daily");
    const [managementReport, setManagementReport] = useState("false");
    const [pocRegReport, setPocRegReport] = useState("false");
    const [verificationRange, setVerificationRange] = useState("");

    useEffect(() => {
        var sfid = "";
        const sessionString = sessionStorage.getItem("user");
        if (sessionString !== null) {
            try {
                const user = JSON.parse(sessionString);
                sfid = user.sfid;
            }
            catch (ex) {
                console.log(ex);
            }

            fetch('/api/admin/getConfigs/' + sfid)
                .then((response) => {
                    response.json()
                        .then((json) => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors);
                            setConfigs(json.message);
                            setLoading(false);
                            for (var config of json.message) {
                                if (config.name === "resetQuestions") {
                                    setMinQuestions(config.value);
                                }
                                else if (config.name === "newMemberTimer") {
                                    setNewMemberTimer(config.value);
                                }
                                else if (config.name === "provisionTime") {
                                    setDailyTimer(config.value);
                                }
                                else if (config.name === "reportTimer") {
                                    setReportTimer(config.value);
                                }
                                else if (config.name === "pocRegReportFreq") {
                                    setPocRegReportTimer(config.value);
                                }
                                else if (config.name === 'managementReport') {
                                    setManagementReport(config.value);
                                }
                                else if (config.name === 'pocRegReportMethod') {
                                    setPocRegReport(config.value);
                                }
                            }
                            setMinQuestions(json[21].value);

                        })
                        .catch((error) => {
                            console.log("json error: " + error);
                        })
                })
                .catch((error) => {
                    console.log("Response error: " + error);
                })
            fetch('/api/admin/getQuestions/' + sfid)
                .then((response) => {
                    response.json()
                        .then((json) => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors);
                            setQuestions(json.message);
                            setLoadingQuestions(false);
                        })
                        .catch((error) => {
                            console.log("Questions json error: " + error);
                        })
                })
                .catch((error) => {
                    console.log("Questions response error: " + error);
                })
        }

    }, [props])

    useEffect(() => {
        var sfid = "";
        const sessionString = sessionStorage.getItem("user");
        if (sessionString !== null) {
            try {
                const user = JSON.parse(sessionString);
                sfid = user.sfid;
            }
            catch (ex) {
                console.log(ex);
            }
            if (clicked === true) {
                fetch('/api/admin/getDataItem/' + sfid + '/' + clickedId)
                    .then((response) => {
                        response.json()
                            .then((text) => {
                                if (text.errors !== null && text.errors !== "") alert(text.errors);
                                setSearch(text.message);
                            })
                            .catch((error) => {
                                console.log("Search Text error: " + error);
                            })
                    })
                    .catch((error) => {
                        console.log("Search Response error: " + error);
                    });
            }
        }
    }, [clicked, clickedId]);


    const handleSubmit = () => {
        var sfid = "";
        const sessionString = sessionStorage.getItem("user");
        if (sessionString !== null) {
            try {
                const user = JSON.parse(sessionString);
                sfid = user.sfid;
            }
            catch (ex) {
                console.log(ex);
            }
            var formData = new FormData();
            formData.append("configsLength", configs.length);
            formData.append("questionsLength", questions.length);

            for (var idx = 0; idx < configs.length; idx++) {
                formData.append("configsKeepSecret" + idx, configs[idx].keepSecret);
                formData.append("configsLabel" + idx, configs[idx].label);
                formData.append("configsName" + idx, configs[idx].name);
                formData.append("configsType" + idx, configs[idx].type);
                formData.append("configsValue" + idx, configs[idx].value);
                // return
            }
            for (idx = 0; idx < questions.length; idx++) {
                formData.append("questionsId" + idx, questions[idx].id);
                formData.append("questionsValue" + idx, questions[idx].value);
                formData.append("questionsNumberOfUses" + idx, questions[idx].numberOfUses);
                // return
            }

            const fetchOptions = {
                method: 'POST',
                body: formData
            }
            fetch('api/admin/UpdateConfig/' + sfid, fetchOptions)
                .then((response) => {
                    response.json()
                        .then((text) => {
                            var fullMessage = "Submit:\n" + text.message + ((text.errors !== null && text.errors !== "") ? ("\nErrors:\n" + test.Errors) : "");
                            alert(fullMessage);
                        })
                        .catch((error) => {
                            console.log("Submit text error: " + error);
                        })
                })
                .catch((error) => {
                    console.log("Submit response error: " + error);
                })
        }
    }


    const shortTimer = [{ name: "15 minutes", value: 15 }, { name: "30 minutes", value: 30 }, { name: "1 hour", value: 60 }];
    const startTime = [
        { name: "12 AM", value: 0 }, { name: "1 AM", value: 1 }, { name: "2 AM", value: 2 },
        { name: "3 AM", value: 3 }, { name: "4 AM", value: 4 }, { name: "5 AM", value: 5 },
        { name: "6 AM", value: 6 }, { name: "7 AM", value: 7 }, { name: "8 AM", value: 8 },
        { name: "9 AM", value: 9 }, { name: "10 AM", value: 10 }, { name: "11 AM", value: 11 },
        { name: "12 PM", value: 12 }, { name: "1 PM", value: 13 }, { name: "2 PM", value: 14 },
        { name: "3 PM", value: 15 }, { name: "4 PM", value: 16 }, { name: "5 PM", value: 17 },
        { name: "6 PM", value: 18 }, { name: "7 PM", value: 19 }, { name: "8 PM", value: 20 },
        { name: "9 PM", value: 21 }, { name: "10 PM", value: 22 }, { name: "11 PM", value: 23 }
    ]
    const reportFrequency = [{ name: "Daily", value: "" }, { name: "Weekly on Mondays", value: "" }, { name: "Weekly on Fridays" },
        { name: "Monthly on the 1st", value: "" }, {name:"Never",value:""}
    ]

    const managementReportDrop = [{ "name": "true", "value": "true" }, { "name": "false", "value": "false" }]

    const handleMouseDown = (e) => {
        setClickedId(e.currentTarget.id);
        setClicked(true);
    }

    const handleUnclick = (e) => {
        setClickedId(e.currentTarget.id);
        setClicked(false);
    }

    const handleNewQuestion = () => {
        var newQ = { id: -1, numberOfUses: 0, value: newQuestion };
        var newObj = questions;
        newObj[newObj.length] = newQ;
        setQuestions(newObj);
        setNewQuestion("");
    }

    const handleUpdatedQuestion = (question, value) => {
        let Obj = questions.filter(currentQuestion => {
            if (currentQuestion === question)
                currentQuestion.value = value
            return true;
        })
        setQuestions(Obj)
    }

    const handleDeleteQuestion = (question) => {
        let obj = questions.filter(currentQuestion => {
            var result;
            if (currentQuestion.value === question.value)
                result = false;
            else result = true;
            return result;
        })
        setQuestions(obj);
    }

    var i = 0;

    const renderAccordions = () => {
        var configTypes = configs.filter((element, index) => index === configs.findIndex(config => config.type === element.type));
        return configTypes.map(configType => {
            i++
            return (
                <Container key={i + "-container"}>
                    <AccordionToggle as={Card} eventKey={i} border="secondary" bg="light" text="black">
                        <div style={{ paddingTop: 5, paddingBottom: 5, fontSize: 17, textAlign: "center" }} >{configType.type}</div>
                    </AccordionToggle>

                    <AccordionCollapse as={Card} eventKey={i}>
                        <Table className="border border-secondary">
                            <tbody>
                                {renderConfigTable(configType.type)}
                            </tbody>
                            {(configType.type === "POC Login and Reset") && renderQuestions()}
                        </Table>
                    </AccordionCollapse>
                </Container>
            )
        })
    }

    const changeConfigDropValue = (value, currentConfig) => {
        let cons = configs
        for (var config of cons) {
            if (config.name === currentConfig.name) {
                config.value = value;
                if (currentConfig.name === "newMemberTimer") {
                    setNewMemberTimer(currentConfig.value);
                }
                else if (currentConfig.name === "provisionTime") {
                    setDailyTimer(currentConfig.value)
                }
                else if (currentConfig.name === "reportTimer") {
                    setReportTimer(currentConfig.value)
                }
                else if (currentConfig.name === "managementReport") {
                    setManagementReport(currentConfig.value)
                }
                else if (currentConfig.name === "pocRegReportMethod") {
                    setPocRegReport(currentConfig.value)
                }
                else if (currentConfig.name === "pocRegReportFreq") {
                    setPocRegReportTimer(currentConfig.value)
                }
            }
        }
        setConfigs(cons);
    }

    const setTimerTitle = (isNewMemberTimer, isProvisioningTimer, isReportTimer, isManagementReport, isPocRegReportTimer, isRegReport) => {
        var title = "";
        if (isNewMemberTimer) title = newMemberTimer;
        else if (isProvisioningTimer) title = dailyTimer;
        else if (isReportTimer) title = reportTimer;
        else if (isManagementReport) title = managementReport;
        else if (isPocRegReportTimer) title = pocRegReportTimer;
        else if (isRegReport) title = pocRegReport;
        return title;
    }

    const renderProvisioningTimers = (config) => {
        var isNewMemberTimer = (config.name === "newMemberTimer");
        var isProvisioningTimer = (config.name === "provisionTime");
        var isReportTimer = (config.name === "reportTimer");
        var isPocRegReportTimer = (config.name === "pocRegReportFreq")
        var isManagementReport = (config.name === "managementReport");
        var isRegReport = (config.name === "pocRegReportMethod");
        var timerArray;
        if (isNewMemberTimer) timerArray = shortTimer;
        else if (isProvisioningTimer) timerArray = startTime;
        else if (isReportTimer || isPocRegReportTimer) timerArray = reportFrequency;
        else if (isManagementReport || isRegReport) timerArray = managementReportDrop;

        return (
            <>
                <DropdownButton
                    title={setTimerTitle(isNewMemberTimer, isProvisioningTimer, isReportTimer, isManagementReport, isPocRegReportTimer, isRegReport)}
                    variant="light"
                >
                    <Dropdown style={{ maxHeight: "196px", overflowY: 'scroll' }}>
                        {timerArray.map((intervalCheck, index) => (
                            <Dropdown.Item
                                key={config.name + index}
                                eventKey={intervalCheck.name}
                                type="radio"
                                value={intervalCheck.name}
                                active={(isNewMemberTimer && newMemberTimer === intervalCheck.name)
                                    || (isProvisioningTimer && dailyTimer === intervalCheck.name)
                                    || (isReportTimer && reportTimer === intervalCheck.name)
                                    || (isPocRegReportTimer && pocRegReportTimer === intervalCheck.name)
                                    || (isManagementReport && managementReport === intervalCheck.name)
                                    || (isRegReport && pocRegReport === intervalCheck.name)}
                                onSelect={e => { changeConfigDropValue(e, config) }}
                            >
                                {intervalCheck.name}
                            </Dropdown.Item>
                        ))}
                    </Dropdown>
                </DropdownButton>
                <FormControl value={(clickedId === config.name) ? search : ""} plaintext readOnly disabled />
            </>
        )
    }

    const renderConfigTable = (type) => {
        return configs.map((config, idx) => {
            return (
                config.type === type ?
                    <tr onMouseLeave={e => { handleUnclick(e) }} key={idx}>
                        <td>{config.label}</td>
                        <td>
                            {renderIndividualConfig(config, idx)}
                        </td>
                        <td>
                            {config.keepSecret &&
                                <HHIEButton
                                    variant="secondary"
                                    id={config.name}
                                    onClick={() => { }}
                                    onMouseDown={(e) => { handleMouseDown(e) }}
                                    title="Show"
                                />
                            }
                        </td>
                    </tr >
                    : <tr key={idx}></tr>
            );
        });
    }

    const preventDefault = (e, numericConfig) => {
        if (numericConfig && (!(e.key >= "0" && e.key <= "9") || (e.keyCode === 8))) return e.preventDefault()
    }

    const renderIndividualConfig = (config, idx) => {
        var configType = "text"
        var numericConfig = (config.type === "POC Login and Reset" || config.name === "samQueryLimit" || config.name === "memberSamLimit" || config.name === "verifyTimeRange");
        if (numericConfig) configType = "number"  
        if (config.name=== "verifyKickoff" || config.name==="validModDate" || config.name==="firstReminder" || config.name==="secondReminder") configType = "date"
        var tempValue = (config.keepSecret ? config.label : config.value);
        var defaultVal = (config.keepSecret ? '' : config.value);
        var keptSecretDefault = ((clickedId === config.name) ? search : "");
        return (
            <Container>
                {config.type !== "Provisioning Timers" && config.name !== "managementReport" && config.name !=="pocRegReportMethod" ?
                    <>
                        {config.type === "Registration Options" && <>Comma-separated emails without spaces</>}
                        <FormControl
                            type={configType}
                            id={config.name}
                            placeholder={tempValue}
                            defaultValue={defaultVal}
                            onKeyPress={(e) => { preventDefault(e, numericConfig) }}
                            onChange={(e) => {
                                if (!numericConfig || Number(e.target.value) > 0) {
                                    if (e.target.value.length <= 2000)
                                        config.value = e.target.value;
                                    else
                                        e.target.value = config.value;
                                    if (config.name === "resetQuestions")
                                        setMinQuestions(config.value);
                                }
                                else {
                                    e.target.value = config.value
                                }

                            }}
                            isInvalid={config.name === "resetQuestions" && questions && (parseInt(config.value) > questions.length)}
                        />
                        {config.keepSecret &&
                            <FormControl
                                defaultValue={keptSecretDefault}
                                plaintext
                                readOnly
                                disabled />
                        }
                    </>
                    : <></>
                }
                {(config.type === "Provisioning Timers" || config.name === "managementReport" || config.name === "pocRegReportMethod") &&
                    <div key={idx + "timer"}>{renderProvisioningTimers(config)}</div>}
            </Container>
        )
    }

    const renderQuestions = () => {
        return (
            <tbody key="questions">
                {!loadingQuestions && questions.map((question, idx) => {
                    return (
                        <tr key={"question" + idx}>
                            <td><FormControl type="text" id={"question" + question.id + idx} value={question.value} onChange={(e) => { handleUpdatedQuestion(question, e.target.value) }} readOnly={question.numberOfUsers > 0} /></td>
                            <td>
                                <HHIEButton
                                    variant="secondary"
                                    disabled={(question.numberOfUses > 0) || (questions.length.toString() === minQuestions)}
                                    onClick={() => { handleDeleteQuestion(question) }}
                                    title="Remove"
                                />
                            </td>
                        </tr>
                    )
                })}
                <tr>
                    <td><FormControl id="newQuestion" onChange={(e) => { setNewQuestion(e.target.value) }} value={newQuestion} /></td>
                    <td>
                        <HHIEButton
                            onClick={() => { handleNewQuestion() }}
                            disabled={newQuestion === ""}
                            title="Add another question"
                        />
                    </td>
                </tr>
            </tbody>
        )
    }


    return (
        <Container className="entire-table">
            <br />
            <h2>Configurations</h2>
            <br />
            <Accordion defaultActiveKey={1}>
                {loading ? "Loading" : renderAccordions()}
            </Accordion>
            <br />
            <div className="d-flex justify-content-center" style={{ marginBottom: '40px' }}>
                <HHIEButton
                    id="config-submit"
                    variant="secondary"
                    type="submit"
                    onClick={handleSubmit}
                    title="Submit"
                    disabled={minQuestions && questions && (minQuestions > questions.length)}
                />
            </div>
        </Container>
    )
}